export const getMethodologyPath = id => `/storefront/document/methodology/${id}`;
